import { Box } from '@mui/material';
import { Pagination, A11y, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useFetchSlidersQuery } from '../../../../store/features/slider/sliderSlice';
import { sliderStyles } from './styles';
import { SliderItem } from './SliderItem';
import { SliderItemSkeleton } from './SliderItemSkeleton';

// Swiper css
import 'swiper/css';
import 'swiper/css/pagination';

const AUTOPLAY_DELAY_IN_MILLISECONDS = 7000; // 7 seconds
export const Slider: React.FC = () => {
  const { isError, isLoading, data: sliders } = useFetchSlidersQuery();

  if (isError) return null;

  if (isLoading) return <SliderItemSkeleton />;

  if (!sliders || sliders.length === 0) return null;

  return (
    <Box sx={sliderStyles.container}>
      <Swiper
        modules={[Pagination, A11y, Autoplay]}
        autoplay={{
          delay: AUTOPLAY_DELAY_IN_MILLISECONDS,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
      >
        {sliders.map((slider) => (
          <SwiperSlide key={slider.id}>
            <SliderItem slider={slider} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
